import {PROMOTED_SPONSORSHIP} from "../promoted-sponsorship-module.consts";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {APP} from "../../../core/app/consts";
import {PromoClickAnalyticsEvent} from "../models/promo.analytics-click-event";

export class PromotedSponsorshipModuleClickHandler extends AnalyticsEventHandler {
  type = PROMOTED_SPONSORSHIP.ACTION_TYPES.sponsorshipClick;

  static injectables = [...AnalyticsEventHandler.injectables];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = PromoClickAnalyticsEvent;
  }

  async action() {
    this.navigationManager.gotoUrl(this.state.sponsorship.externalUrl, false, true);

    const params = {
      source: APP.ANALYTICS.SOURCES.mainHeader,
      promoName: this.state.sponsorship.name
    };

    const showEvent = new this.eventType(params);

    this.analyticsService.createEvent(showEvent);
  }
}
